<template>
  <div>
    <div v-if="hasOverflow" class="d-flex align-center scroll-hint mb-1">
      <v-btn icon x-small @mousedown.prevent="startScroll(-300)" @mouseup="stopScroll" @mouseleave="stopScroll" :style="{ visibility: canScrollLeft ? 'visible' : 'hidden' }">
        <v-icon small>mdi-chevron-left</v-icon>
      </v-btn>
      <span class="body-2 grey--text text--darken-2">{{ $t('app.tableScrollHint') }}</span>
      <v-btn icon x-small @mousedown.prevent="startScroll(300)" @mouseup="stopScroll" @mouseleave="stopScroll" :style="{ visibility: canScrollRight ? 'visible' : 'hidden' }">
        <v-icon small>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DataTableScrollHint',
  data() {
    return {
      hasOverflow: false,
      canScrollLeft: false,
      canScrollRight: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      const wrapper = this.$el.querySelector('.v-data-table__wrapper');
      if (wrapper) {
        this._scrollWrapper = wrapper;
        wrapper.addEventListener('scroll', this.updateScrollState, { passive: true });
        this._resizeObserver = new ResizeObserver(this.updateScrollState);
        this._resizeObserver.observe(wrapper);
        this.updateScrollState();
      }
    });
  },
  beforeDestroy() {
    if (this._scrollWrapper) {
      this._scrollWrapper.removeEventListener('scroll', this.updateScrollState);
    }
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
    this.stopScroll();
  },
  methods: {
    updateScrollState() {
      const el = this._scrollWrapper;
      if (!el) return;
      const { scrollLeft, scrollWidth, clientWidth } = el;
      this.hasOverflow = scrollWidth > clientWidth;
      this.canScrollLeft = scrollLeft > 0;
      this.canScrollRight = scrollLeft + clientWidth < scrollWidth - 1;
    },
    scrollTable(amount) {
      if (this._scrollWrapper) {
        this._scrollWrapper.scrollBy({ left: amount, behavior: 'smooth' });
      }
    },
    startScroll(amount) {
      this.scrollTable(amount);
      this._scrollTimeout = setTimeout(() => {
        this._scrollInterval = setInterval(() => this.scrollTable(amount), 100);
      }, 400);
    },
    stopScroll() {
      clearTimeout(this._scrollTimeout);
      clearInterval(this._scrollInterval);
    },
  },
}
</script>
